/* ============================================================
   PEMILIH "POST TO" — Control Panel v3.9 (2026-09-29)
   RUPA SAHAJA. Nilai + simpanan hidup dalam App.jsx (`postTo` +
   `pilihPostTo`, kunci storan `sesaat_post_to_v1`; `postToBerkesan`
   sentiasa 'tiktok' bila pelanggan tiada akses FB Reels).

   Rupa: tiga KOTAK ikon "pilih satu" (diluluskan user 2026-09-29),
   menggantikan tiga baris suis. Suis membayangkan dua tempat boleh
   hidup serentak, dan menekan suis yang sudah hidup tidak berbuat
   apa-apa — kotak "pilih satu" menyatakan peraturan sebenar.
     · Susunan: TikTok · Facebook Reels · Threads (kanan sekali).
     · TIADA ayat nota di bawah ikon atau di bawah kotak (arahan user).
     · Kotak DIPILIH = isian gelap bertulisan cerah, SAMA seperti pilihan
       aktif Cara post (`.s-cara__baris--aktif` dalam CaraPostV39.css:
       `--s-primary` / `--s-primary-ink`, jadi ia terbalik sendiri dalam
       tema gelap) — arahan user 29 Sept. Bentuk + gaya kotak SAMA dengan
       `LaluanFbV39` (Posting route) — ubah satu, semak yang satu lagi.
       Monokrom, tiada emoji.

   Kotak berkunci BUKAN kawalan (tiada kawalan palsu): `disabled`, garis
   putus + ikon lock. Threads sentiasa berkunci. Facebook Reels berkunci
   bila tiada akses — kekal dipapar supaya pelanggan tahu ciri ini wujud
   (keputusan user 2026-08-30).

   Ikon jenama: laluan SVG daripada Tabler Icons 3.48 (lesen MIT), garis
   `currentColor` supaya ikut tema terang/gelap. Material Symbols (ikon
   `LaluanFbV39`) tiada logo jenama.
   ============================================================ */

const IKON = {
    tiktok: 'M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917',
    facebook: 'M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3',
    threads: 'M19 7.5c-1.333 -3 -3.667 -4.5 -7 -4.5c-5 0 -8 2.5 -8 9s3.5 9 8 9s7 -3 7 -5s-1 -5 -7 -5c-2.5 0 -3 1.25 -3 2.5c0 1.5 1 2.5 2.5 2.5c2.5 0 3.5 -1.5 3.5 -5s-2 -4 -3 -4s-1.833 .333 -2.5 1',
};

const PILIHAN = [
    { id: 'tiktok', label: 'TikTok' },
    { id: 'facebook', label: 'Facebook Reels' },
    { id: 'threads', label: 'Threads' },
];

function IkonJenama({ d }) {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d={d} />
        </svg>
    );
}

export default function PostToV39({ t, postTo, aksesFb, onPilih }) {
    const tajuk = t('workspace.page.sect.postTo', 'Post To');
    return (
        <div role="radiogroup" aria-label={tajuk}
            style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 8 }}>
            {PILIHAN.map((p) => {
                const kunci = p.id === 'threads' || (p.id === 'facebook' && !aksesFb);
                const on = !kunci && postTo === p.id;
                return (
                    <button
                        key={p.id}
                        type="button"
                        role="radio"
                        aria-checked={on}
                        disabled={kunci}
                        onClick={() => { if (!kunci && !on) onPilih(p.id); }}
                        style={{
                            position: 'relative', minWidth: 0,
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4,
                            padding: '10px 5px', font: 'inherit', textAlign: 'center', lineHeight: 1.2,
                            cursor: kunci ? 'not-allowed' : 'pointer',
                            borderRadius: 'var(--s-r)', background: on ? 'var(--s-primary)' : 'var(--s-fill)',
                            border: on ? '1px solid var(--s-primary)'
                                : kunci ? '1px dashed var(--s-line-strong)' : '1px solid var(--s-line-strong)',
                            color: on ? 'var(--s-primary-ink)' : 'var(--s-ink-3)',
                            opacity: kunci ? 0.55 : 1,
                        }}
                    >
                        {kunci && (
                            <span className="material-symbols-outlined" aria-hidden="true"
                                style={{ position: 'absolute', top: 4, right: 5, fontSize: 13 }}>lock</span>
                        )}
                        <IkonJenama d={IKON[p.id]} />
                        <span style={{ fontSize: 12, fontWeight: on ? 700 : 500 }}>{p.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
